export default __webpack_public_path__ + "static/media/enter-point.ed00e48e.svg";